export const cooperationUtil = [
    {
        cooperationText: 'Jazzve Coffee, Armenia’s largest chain of cafes with its own brand of coffee. Our task was to create an original comics series to promote Jazzve’s new line of coffee products of Robusta, Arabica, and blended. The comics will revolve around   the story of Jazzve’s three main mascots — Gohar, Anush, and Tamar — characters from renowned tales by famous Armenian writer Hovhannes Tumanyan.'

    },
    {
        cooperationText: '"Honest Thieves" is an Armenian comedy by Gor Kirakosyan. Our task was to create an original poster for the movie with the main characters. Poster introduced the main concept of the movie.'
    }
];